/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface PutExperienceRequestContent
 */
export interface PutExperienceRequestContent {
    /**
     * Roblox identifier for the experience's published game.
     * @type {string}
     * @memberof PutExperienceRequestContent
     */
    robloxGameId: string;
    /**
     * Optional assets that represent this experience in catalogs and UIs.
     * @type {Array<string>}
     * @memberof PutExperienceRequestContent
     */
    assetIds?: Array<string>;
}


/**
 * Check if a given object implements the PutExperienceRequestContent interface.
 */
export function instanceOfPutExperienceRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "robloxGameId" in value;
    return isInstance;
}

export function PutExperienceRequestContentFromJSON(json: any): PutExperienceRequestContent {
    return PutExperienceRequestContentFromJSONTyped(json, false);
}

export function PutExperienceRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutExperienceRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'robloxGameId': json['robloxGameId'],
        'assetIds': !exists(json, 'assetIds') ? undefined : json['assetIds'],
    };
}

export function PutExperienceRequestContentToJSON(value?: PutExperienceRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'robloxGameId': value.robloxGameId,
        'assetIds': value.assetIds === undefined ? undefined : value.assetIds,
    };
}

